<template>
    <list-item
        @click="onRowClick"
    >
        <template slot="title">
            {{formInstance.form.name}}
            <div class="d-flex text-sm" v-if="isCustomForm">
                <svg-image
                    class="mr-1"

                    :src="customFormIcon"
                    width="15px"
                    height="19px"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                />
                <span v-if="isJobForm">Custom form</span>
                <span class="text-primary" v-else>Shared library</span>
            </div>
        </template>
        <template slot="center">
            <div class="d-flex flex-table--cell mr-3" v-if="formInstance.settings.expires">
                <svg-image
                    :src="`/svg/${resource_group}/notification.svg`"
                    class="mr-1"
                    width="15px"
                    height="19px"
                    color="danger"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                />
                <span>{{ expiryLabel }}</span>
            </div>
            <div class="flex-table--cell">
                <label class="toggle mb-0">
                    <input type="checkbox" :checked="formInstance.active" @click="onToggleStatus">
                    <span class="toggle--slider"></span>
                </label>
            </div>
            <div class="flex-table--cell" style="width:25px">
                <div v-if="isCustomForm" class="btn-group">
                    <svg-image
                        :src="'/svg/' + resource_group +'/more.svg'"
                        width="20px"
                        height="25px"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    ></svg-image>
                    <div class="dropdown-menu dropdown-menu-right">
                        <svg-image
                            :src="'/svg/' + resource_group + '/forms.svg'"
                            width="20px"
                            height="20px"
                            highlight="primary"
                            class="dropdown-item"
                            :auto_hover="true"
                            :spaced="true"
                            @click="onDuplicate"
                        >
                            <span class="text-danger">Duplicate</span>
                        </svg-image>

                        <a class="list-group-item-action" :href="completeEditUrl">
                            <svg-image
                                :src="'/svg/' + resource_group + '/edit.svg'"
                                width="20px"
                                height="20px"
                                highlight="positive"
                                class="dropdown-item"
                                :auto_hover="true"
                                :spaced="true"
                            >
                                <span class="text-danger">Edit</span>
                            </svg-image>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </list-item>
</template>

<script>
    import ListItem from "../ListComponent/ListItem";

    export default {
        name: 'JobFormLibraryFormListItem',

        components: {
            ListItem
        },

        props: {
            formInstance: Object,

            submissionUrl : String,
            editUrl       : String,
            toggleUrl     : String
        },

        computed: {
            completeSubmissionUrl: function(){
                return this.submissionUrl.replace('?', this.formInstance.id)
            },

            completeEditUrl: function(){
                return this.editUrl.replace('?', this.formInstance.id)
            },

            completeToggleUrl: function(){
                return this.toggleUrl.replace('?', this.formInstance.id)
            },

            isCustomForm: function(){
                return this.formInstance.form.type === 'custom'
            },

            isJobForm: function(){
                return this.formInstance.form.is_company_library === false
            },

            customFormIcon: function(){
                return this.isJobForm
                    ? `/svg/${this.resource_group}/custom-form.svg`
                    : `/svg/${this.resource_group}/shared-form.svg`
            },

            expiryLabel: function(){
                if(!this.formInstance.settings.expires){
                    return null
                }

                let label = this.formInstance.settings.repeats
                    ? 'Repeats'
                    : 'Expires';

                if(this.formInstance.settings.expiration_method === 'day'){
                    return `${label} Daily`
                }

                if(this.formInstance.settings.expiration_method === 'month'){
                    return `${label} Monthly`
                }

                const dayMap = {
                    0: 'Monday',
                    1: 'Tuesday',
                    2: 'Wednesday',
                    3: 'Thursday',
                    4: 'Friday',
                    5: 'Saturday',
                    6: 'Sunday'
                }

                return (
                    this.formInstance.settings.expiration_period === 1
                        ? `${label} weekly`
                        : `${label} every ${this.formInstance.settings.expiration_period}`
                    )
                    + ` on a ${dayMap[this.formInstance.settings.first_day]}`;
            }
        },

        methods: {
            onRowClick: function(){
                window.location.href = this.completeSubmissionUrl
            },

            onDuplicate: function(){
                this.$emit('duplicate')
            },

            onToggleStatus: function(e){
                axios.patch(this.completeToggleUrl, {
                    active: e.target.checked
                });
            }
        }
    }
</script>
